export default "__VITE_ASSET__18acd2ff__"